import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/basic";

class Supplier {
  /* 工艺参数定义 */
  @observable supplierName = "";
  @observable modalVisible = false;
  @observable tableData = [];
  @observable PageInfo = {};

  @action.bound async getParams(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.supplierList,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 新增参数
  @action.bound async addParams(params) {
    this.isLoading = true;
    const url = services.requestUrl.saveSupplier;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 删除参数
  @action.bound async deleteParams(params) {
    this.isLoading = true;
    try {
      let res = await services.putRequest(
        services.requestUrl.deleteSupplier,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }

  /* 通用使用------ */
  //打开/关闭模态框
  @action.bound modalChange(type, record) {
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
    }
    this.modalVisible = !this.modalVisible;
  }
}

let SupplierStore = new Supplier();
export default SupplierStore;
